import React from 'react';

const Register = ()=>{
    return (
    <div>
        Hola
    </div>)
}

export default Register;